import { render } from "./Account.vue?vue&type=template&id=af8d36c8&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=af8d36c8&lang=scss&scoped=true"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8d36c8"]])

export default __exports__